import _ from "lodash";
import { CustomSelectImpl } from "./customSelect";
export class SingleSelect extends CustomSelectImpl {
    setSelected(chosenItem) {
        this.items.forEach((i) => (i.selected = false));
        chosenItem.selected = true;
        this.getListItems().removeClass("selected").attr("aria-selected", "false");
        const item = this.getListItems()
            .toArray()
            .find((l) => $(l).data("item").value === chosenItem.value);
        if (item)
            $(item).addClass("selected").attr("aria-selected", "true");
    }
    getDisplayText() {
        const selectedItem = this.items.find((i) => i.selected);
        return (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.displayName) || "";
    }
    shouldHideOnClick(e) {
        const target = $(e.target);
        const clickIsInThisSearch = target.closest("input")[0] === this.searchInput[0];
        const clickIsInThisListGroup = !_.some(target.closest(".custom-select-list-item")) &&
            _.some(this.list.find(".custom-select-list-group").toArray(), (g) => g === target.closest(".custom-select-list-group")[0]);
        return !clickIsInThisListGroup && !clickIsInThisSearch;
    }
    preventKeyboardClosure() {
        return false;
    }
    selectNext(key) {
        const next = this.items[_.findIndex(this.items, (i) => !!i.selected) +
            (key === "ArrowDown" ? 1 : -1)];
        if (!next)
            return;
        this.setSelected(next);
        this.emit("change", true);
        this.setDisplayText();
    }
    selectBySearchKeys() {
        if (!this.searchKeys)
            return;
        const item = this.items.find((i) => i.displayName.toLowerCase().startsWith(this.searchKeys.toLowerCase()));
        if (!item)
            return;
        this.setSelected(item);
        this.emit("change", true);
        this.setDisplayText();
    }
    autoSelect(searchText) {
        if (!searchText)
            return;
        const exactMatches = this.items.filter((i) => i.displayName === searchText);
        const partialMatches = this.items.filter((i) => i.displayName.startsWith(searchText));
        if (exactMatches.length === 1 && partialMatches.length === 1) {
            this.setSelected(exactMatches[0]);
            this.emit("change", true);
            this.setDisplayText();
            this.hideList();
        }
    }
}
